import React from 'react';
import styles from '../ManageTeamDrawer.module.scss';
import ManageUserTable from '../../../modules/Investor/ManageUser/ManageUserTable/ManageUserTable';
import aicaLoader from '../../../assets/aica-loader.svg';
import clsx from 'clsx';
import Button from '../../../common/_custom/Button/Button';
import AddUserModal from '../../../modules/Investor/ManageUser/ManageUserTable/components/AddUserModal';
import { plusWhite } from '../../../assets/hostedassets';
import { useManageTeam } from '../useManageTeam';

type ManageTeamProps = {
    selectedOrgName?: string;
    orgId?: string;
    userType?: string;
};

const ManageTeam = ({ selectedOrgName, orgId, userType }: ManageTeamProps) => {
    const {
        headers,
        rows,
        isRowsLoading,
        pageNo,
        showAddUserModal,
        currentRowUser,
        setShowAddUserModal,
        setCurrentRowUser,
        fetchTeamData,
        handleAddUser,
    } = useManageTeam(orgId, userType);

    const renderHeader = () => {
        const displayOrgName = selectedOrgName || (rows.length > 0 ? rows[0].organizationName : '');

        return (
            <div className={styles.HeaderContainerForCompanySide}>
                <div className={styles.HeaderLeft}>
                    <h2 className={styles.HeadingTextForCompany}>Manage Team</h2>
                    {displayOrgName && <div className={styles.CompanyName}>{displayOrgName}</div>}
                </div>
                <Button
                    style={{ marginRight: 40, marginTop: 0 }}
                    icon={plusWhite}
                    text="Add User"
                    onClick={() => setShowAddUserModal(true)}
                    variant="purple"
                />
            </div>
        );
    };

    const renderTable = () => {
        if (isRowsLoading) {
            return (
                <div className={styles.LoadingContainer}>
                    <img src={aicaLoader} alt="Loading..." width={'80px'} />
                </div>
            );
        }

        return (
            <ManageUserTable
                headers={headers}
                rows={rows}
                isRowsLoading={isRowsLoading}
                isCompanySide={true}
                setShowAddUserModal={setShowAddUserModal}
                setCurrentRowUser={setCurrentRowUser}
                onUsersUpdate={() => fetchTeamData(pageNo)}
                allowUserTypeEdit={true}
            />
        );
    };

    return (
        <div className={styles.TableContainer}>
            {renderHeader()}
            <div className={clsx(styles.TableContainerCompanySide)}>{renderTable()}</div>
            {showAddUserModal && (
                <AddUserModal
                    showAddUserModal={showAddUserModal}
                    setShowAddUserModal={setShowAddUserModal}
                    currentRowUser={currentRowUser}
                    onClose={() => setShowAddUserModal(false)}
                    fetchRows={fetchTeamData}
                    pageNo={pageNo}
                    onUserAdded={handleAddUser}
                    allowUserTypeEdit={true}
                />
            )}
        </div>
    );
};

export default ManageTeam;
